import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CareersPage from "../pages/careers/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
